// Lib
import React from 'react';
import Box from '@mui/material/Box';

// Components
import ListButton from '../../Button/ListButton';
import GridButton from '../../Button/GridButton';

// Styles
import { useStyles } from './ViewButtonsStyles';

const ViewButtons = ({ isListView, onChangeView, isMobileMode }) => {
  const { classes } = useStyles({ isMobileMode });

  return (
    <Box display="flex" alignItems="center">
      <ListButton
        onClick={onChangeView('list')}
        isActive={isListView}
        className={classes.listButton}
      />
      <GridButton
        onClick={onChangeView('grid')}
        isActive={!isListView}
        className={classes.gridButton}
      />
    </Box>
  );
};

export default ViewButtons;
